import React, { useEffect, useState, useRef } from "react";
import Header from "../components/Header";

import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Accordion from 'react-bootstrap/Accordion';
import { useTranslation } from 'react-i18next';
import { useAxios } from "../services/useAxios";
import Nodata from "../components/NoData";


export default function OftenQnA() {
    const { t } = useTranslation();
    const [data, setData] = useState({});
    const [request] = useAxios();
    const [page, setPage] = useState(0);
    const [dataList, setDataList] = useState([]);
    const [selectCate, setSelectCate] = useState("");

    const fetchData = async (page) => {
        const response = await request.post("/app/mypage/getBbsNttListAPI", {
            bbsSn : 5,
            pageIndex : page,
            aditfield1 :selectCate==='all'?'':selectCate
        });

        if(response.data.resultCode === 200){
            setData(response.data.result);
            setDataList((prevData) => [...prevData, ...response.data.result.resultList]);
            console.log(response.data.result);
        }
    };
   
      useEffect(() => {
        console.log(page)
        if(page > 0){        
            setDataList([])
            setPage(1)            
            fetchData(page);
        }
      }, [selectCate]);


   
  useEffect(() => {
    if(page > 0){
        fetchData(page);    
    }
  }, [page]);


  const handleObserver = (entries) => {
    const target = entries[0];
    if (target.isIntersecting ) {
        setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, {
      threshold: 0, //  Intersection Observer의 옵션, 0일 때는 교차점이 한 번만 발생해도 실행, 1은 모든 영역이 교차해야 콜백 함수가 실행.
    });
    // 최하단 요소를 관찰 대상으로 지정함
    const observerTarget = document.getElementById("observer");
    // 관찰 시작
    if (observerTarget) {
      observer.observe(observerTarget);
    }
  }, []);

    return (
        <div>
            <div className="backGround bgBlue"></div>
            <Header type="cart" pageTitle={t(`Message.my_salee_screen_favorite_quest`)}/>


            <div className="oftenQna">                
                 <Nav variant="tabs"  defaultActiveKey="all" className="tabType2"  onSelect={(select) => setSelectCate(select) }>                        
                    <Nav.Item>
                        <Nav.Link eventKey="all">{t(`Message.common_all`)}</Nav.Link>
                    </Nav.Item>
                    {data.cmDetailCodeList && data.cmDetailCodeList.map((obj, index) => (  
                    <Nav.Item key={index}>
                        <Nav.Link eventKey={obj.code}>{obj.codeNm}</Nav.Link>
                    </Nav.Item>
                    ))} 
                </Nav>        
                {dataList && dataList.length === 0?(
                <div className="floatCenter">
                    <Nodata text={t(`Message.faq_bbs_refresher_list_empty`)}/>
                </div> 
                ):(
              
                <div className="tabCont">
                    {dataList && dataList.map((obj, index) => (
                    <Accordion className="oftenQnaAccodian" key={index}>
                        <Accordion.Item eventKey={obj.nttSn}>
                            <Accordion.Header>
                                <div className="qnaWr">
                                    <p className="cOrg fw600">Q.</p>
                                    <p className="tag">{data.cmDetailCodeList.find((e)=> e.code === obj.aditfield1).codeNm}</p>
                                    <p className="qna">{obj.nttSj}</p>
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="answerWr">
                                    <p className="cBlue fw600">A.</p>
                                    <p className="answer" dangerouslySetInnerHTML={{ __html: obj.nttCn }}></p>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                    ))} 
                    
                    
                </div>
                )}
                <div id="observer" className="oqContWr"></div>
            </div>
        </div>
    );
};